import { Region } from '../types/orderTypes';
import { BundleForRelabelling } from '../types/bundleTypes';
import { settings } from '../settings';
import Fetch from '../utils/fetch';

export async function fetchRelabelList(
  region: Region
): Promise<BundleForRelabelling[]> {
  const response = await Fetch.get({
    url: `${settings.newApiUrl}/hubsort/relabelling-list?region=${region}`,
  });
  if (response.ok) {
    return await response.json();
  } else {
    [];
  }
}
